<div class="form-field">
  <input class="form-field__input" type="text" #newquery
    id="search"
    placeholder="Search passwords"
    [disabled]="secretsLength === 0"
    [value]="query"
    (keyup)="submitSearch(newquery.value)"
    autofocus="autofocus"/>
</div>
